import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Footer from "./body/Footer.jsx";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Proyectos from "./Pages/Proyectos.jsx";
import Inicio from "./Inicio.jsx";
import ScrollToTop from './ScrollToTop';
import Login from "./Pages/Login.jsx";
import ProyectosAdmin from "./admin/proyectos-admin.jsx";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <App /> {/* Navbar */}
      
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/servicios" element={<Proyectos />} />
        <Route path="/login" element={<Login />} />
        <Route path="/servicios-admin" element={<ProyectosAdmin />} />
      </Routes>

      <Footer /> {/* Footer debajo de las rutas */}
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

